import { Coupon } from '../components/Coupon/Coupon';
import { useCouponService } from '../services/useCouponService';

export interface CouponContainerProps {}

export const CouponContainer: React.FC<React.PropsWithChildren<CouponContainerProps>> = () => {
  const { isHide, isCouponAvailable, buttonColor, impressionCouponBannerRef, handleClickDownload } = useCouponService();

  if (isHide) {
    return null;
  }

  return (
    <Coupon
      ref={impressionCouponBannerRef}
      buttonColor={buttonColor}
      isCouponAvailable={isCouponAvailable}
      handleClickDownload={handleClickDownload}
    />
  );
};
